import React from 'react';
import './reportAnswerPercentage.scss';
import {QuestionAnswerEnum, QuestionAnswerType} from '../../../analytics';

interface ReportAnswerPercentageProps {
    label: string;
    percentage: number;
    type: QuestionAnswerType;
    showCorrect?: boolean;
    isPresenter?: boolean;
    fullColor?: boolean; // * Remove this prop and all features connected to it once html2canvas is removed (it does not support clip-path)
}

function ReportAnswerPercentage(props: ReportAnswerPercentageProps): JSX.Element {
    const {percentage, label, type, showCorrect, isPresenter, fullColor} = props;

    const getStatusClass = (type: QuestionAnswerType, label: string): string => {
        if (!isPresenter || !showCorrect) return QuestionAnswerEnum.NEUTRAL;
        if (label === 'All correct' || type === QuestionAnswerEnum.ALL_CORRECT) {
            return QuestionAnswerEnum.ALL_CORRECT;
        }
        return type;
    };

    return (
        <div className="c-reportAnswerPercentage">
            <div
                className={`c-reportAnswerPercentage__background ${
                    fullColor ? `c-reportAnswerPercentage__background--${getStatusClass(type, label)}` : ''
                }`}
            >
                <span>{label}</span>
                <span className="c-reportAnswerPercentage__background_percentage">{`${percentage}%`}</span>
            </div>
            <div
                className={`c-reportAnswerPercentage__foreground c-reportAnswerPercentage__foreground--${getStatusClass(type, label)}`}
                style={{clipPath: `inset(0 ${100 - percentage}% 0 0)`}}
            >
                <span>{label}</span>
                <span className="c-reportAnswerPercentage__foreground_percentage">{`${percentage}%`}</span>
            </div>
        </div>
    );
}

export default ReportAnswerPercentage;
